module.exports = __webpack_public_path__ + "img/Speaker=Jonny Hsu.2953bebe.png";